import { ActivatedRoute } from "@angular/router";
import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { GenreService } from "src/app/services/genre.service";
import { catchError, map, throwError } from "rxjs";
import { FormService } from "src/app/services/form.service";
import { MatSnackBar } from "@angular/material/snack-bar";
import { SeoServiceService } from "src/app/services/seo-service.service";

@Component({
  selector: "app-contact-us",
  templateUrl: "./contact-us.component.html",
  styleUrls: ["./contact-us.component.scss"],
})
export class ContactUsComponent implements OnInit {
  formGroup: FormGroup;
  productList: string[] = [
    "Interactive Flat Panel",
    "IFP Protection (Shutter)",
    "All In One PC",
    "LMS",
    "K-12 Digital Content",
    "Digital E-Library"
  ];
  data = {
    myName: "",
    myResume: "",
    countryCode: "+91",
    mobileNumber: "",
    email: "",
    comment: "",
    selectedGenre: "",
    genreList: true,
  };

  fetch: string | null = null;
  name: string = "";
  formOf = {
    title1: "",
    title2: "",
    sub: "",
    file: "",
    img: "",
  };

  constructor(
    private activatedRoute: ActivatedRoute,
    private formBuilder: FormBuilder,
    private genre: GenreService,
    private form: FormService,
    private snackbar: MatSnackBar,
    private seoService: SeoServiceService
  ) {
    this.formGroup = this.formBuilder.group({
      myName: ["", [Validators.required, Validators.minLength(3)]],
      myResume: [null],
      countryCode: ["+91"],
      mobileNumber: ["", [Validators.required, Validators.pattern("^[0-9]{10}$")]],
      email: ["", [Validators.required, Validators.email]],
      selectedGenre: ["", Validators.required],
      comment: [""],
    });
  }

  ngOnInit(): void {
    this.seoService.createLinkForCanonicalURL();
    this.activatedRoute.paramMap.subscribe((params) => {
      this.fetch = params.get("name");
      // console.log(this.fetch);
      if (this.fetch !== null) {
        this.name = this.fetch === "contact-us" ? "contactUs" : this.fetch;
        this.formGroup.reset();
      }
      this.processOption();
    });
  }

  processOption() {
    const options: { [key: string]: any } = {
      doorsteps: {
        title1: "Trainer at",
        title2: " Your Doorstep",
        sub: "",
        file: "",
        img: "trainer_at_home.svg",
      },
      connectLegends: {
        title1: "Connect with",
        title2: " Legends",
        sub: "",
        file: "",
        img: "Legends.jpg",
      },
      professionalTrainer: {
        title1: "Become a",
        title2: " Professional Trainer",
        sub: "",
        file: "true",
        img: "proffessional.svg",
      },
      Sales: {
        title1: "Contact B2B",
        title2: " Sales",
        sub: "",
        file: "",
        img: "sales.svg",
      },
      partnership: {
        title1: "Interested in",
        title2: " Partnership?",
        sub: "true",
        file: "",
        img: "partnership.svg",
      },
      contactUs: {
        title1: "Contact",
        title2: " Us",
        sub: "",
        file: "",
        img: "contact_us.svg",
      },
      "contact-us": {
        title1: "Contact",
        title2: " Us",
        sub: "",
        file: "",
        img: "contact_us.svg",
      },
    };

    this.formOf = options[this.name];
  }

  submit() {
    if (this.formGroup.valid) {
      // console.log(this.formGroup.value);
      switch (this.name) {
        case "doorsteps":
          // Make POST API call for 'doorsteps'
          this.ServiceDoor();
          break;

        case "connectLegends":
          // Make POST API call for 'connectLegends'
          this.LegendService();
          break;

        case "professionalTrainer":
          // Make POST API call for 'professionalTrainer'
          this.BecomeTeacher();
          break;

        case "sales":
          // Make POST API call for 'sales'
          this.ContactUs("sales");
          break;

        case "partnership":
          // Make POST API call for 'partnership'
          this.ContactUs("partnership");
          break;

        case "contactUs":
        case "contact-us":
          // Make POST API call for 'contactUs'
          this.ContactUs("contactUs");
          break;

        // Add more cases as needed for other form types

        default:
          console.error("Invalid form type");
          break;
      }
      this.formGroup.reset();
    } else {
      // Handle form validation errors
      // console.log(this.formGroup);
    }
  }

  ContactUs(type: string) {
    let toComent = "";
    const userComment = this.formGroup.value.comment ? this.formGroup.value.comment : '';
    if (type === "sales") {
      toComent = "Submitted for Sales" + (userComment ? ': ' + userComment : '');
    } else if (type === "partnership") {
      toComent = "Submitted for Partnership" + (userComment ? ': ' + userComment : '');
    } else {
      toComent = "Contact Us" + (userComment ? ': ' + userComment : '');
    }
    const body = {
      name: this.formGroup.value.myName,
      email: this.formGroup.value.email,
      message: toComent,
      mobile: this.formGroup.value.mobileNumber,
      genre: this.formGroup.value.selectedGenre,
    };

    this.form.contactUs(body).subscribe(
      (res: any) => {
        if (res.error === false) {
          this.snackbar.open(res.message, "Ok", { duration: 4000 });
        } else {
          // console.log("Login failed: ", res.error_message);
        }
      },
      (error) => {
        console.error("Error:", error);
      }
    );
  }

  BecomeTeacher() {
    const body = {
      name: this.formGroup.value.myName,
      mobile: this.formGroup.value.mobileNumber,
      email: this.formGroup.value.email,
      resume: this.formGroup.value.myResume,
      genre: this.formGroup.value.selectedGenre,
      comment: this.formGroup.value.comment,
    };

    this.form.becomeTeacher(body).subscribe(
      (res: any) => {
        if (res.error === false) {
          this.snackbar.open(res.message, "Ok", { duration: 4000 });
        } else {
          // console.log("Login failed: ", res.error_message);
        }
      },
      (error) => {
        console.error("Error:", error);
      }
    );
  }

  ServiceDoor() {
    const body = {
      name: this.formGroup.value.myName,
      mobile: this.formGroup.value.mobileNumber,
      genre: this.formGroup.value.selectedGenre,
      comment: this.formGroup.value.comment,
    };

    this.form.serviceDoor(body).subscribe(
      (res: any) => {
        if (res.error === false) {
          this.snackbar.open(res.message, "Ok", { duration: 4000 });
        } else {
          // console.log("Login failed: ", res.error_message);
        }
      },
      (error) => {
        console.error("Error:", error);
      }
    );
  }

  LegendService() {
    const body = {
      name: this.formGroup.value.myName,
      mobile: this.formGroup.value.mobileNumber,
      email: this.formGroup.value.email,
      genre: this.formGroup.value.selectedGenre,
      comment: this.formGroup.value.comment,
    };

    this.form.legendService(body).subscribe(
      (res: any) => {
        if (res.error === false) {
          this.snackbar.open(res.message, "Ok", { duration: 4000 });
        } else {
          // console.log("Login failed: ", res.error_message);
        }
      },
      (error) => {
        console.error("Error:", error);
      }
    );
  }
}
